// Bootstrap imports: ca. 10kB for this bootstrap accordion functionality
import Collapse from 'bootstrap/js/dist/collapse';
import { isMobileScreen, isMobileDevice } from '../Helper/helper';

const SELECTOR__CE_SOURCES_LINKS_ACCORDION_ITEM =
  '.article__section .ce--sources-and-links .accordion';

let sourcesLinksAccordionItems;
let isMobile = isMobileScreen();

const toggleCeSourcesLinksAccordionItems = () => {
  sourcesLinksAccordionItems.each(function() {
    $(this)
      .find('.accordion-button')
      .attr('aria-expanded', isMobile ? 'true' : 'false');

    if (isMobile) {
      $(this)
        .find('.accordion-collapse')
        .addClass('show')
        .removeClass('collapse');
    } else {
      $(this)
        .find('.accordion-collapse')
        .removeClass('show')
        .addClass('collapse');
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  var accordions = document.querySelectorAll('.accordion');
  accordions.forEach(function(accordion) {
    new Collapse(accordion, {
      toggle: false, // Prevent auto-collapsing
      // parent: false // Prevent auto-collapsing of other collapsibles
    });
  });

  sourcesLinksAccordionItems = $(SELECTOR__CE_SOURCES_LINKS_ACCORDION_ITEM);
  if (sourcesLinksAccordionItems.length < 1) {
    return;
  }

  toggleCeSourcesLinksAccordionItems();

  window.addEventListener('resize', function() {
    isMobile = isMobileScreen();
    toggleCeSourcesLinksAccordionItems();
  });
});
